export function resolveTenant(): string | null {
  const hostname = window.location.hostname
  if (hostname.includes('localhost')) {
    // return '127.0.0.1'
    return 'dev.nobrinde.immera.io'
  }
  return hostname
}
